<modal-header title="Start, Kick, or Replace {{menuItemInventory.menuItem.name}} Keg"></modal-header>
<ion-content>
    <ion-grid [formGroup]="formGroup">
        <ion-row>
            <ion-col class="ion-text-center">
                <div>Back Of House Inventory</div>
                <span class="count">{{!!backOfHouseInventory ? backOfHouseInventory.currentCount : 'Not Tracked'}}</span>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-item>
                    <ion-label position="floating">Size</ion-label>
                    <ion-select name="containerQuantity" formControlName="containerQuantity" interface="popover">
                        <ion-select-option [value]="1984">Half Barrel (15.5 Gal)</ion-select-option>
                        <ion-select-option [value]="1690">50 Litre Keg (13.2 Gal)</ion-select-option>
                        <ion-select-option [value]="1382">Firkin (10.8 Gal)</ion-select-option>
                        <ion-select-option [value]="992">Quarter Barrel (7.75 Gal)</ion-select-option>
                        <ion-select-option [value]="690">Pin (5.4 Gal)</ion-select-option>
                        <ion-select-option [value]="661">Sixth Barrel (5.16 Gal)</ion-select-option>
                        <ion-select-option [value]="640">Cornelius (5 Gal)</ion-select-option>
                    </ion-select>
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
<ion-footer *ngIf="menuItemInventory.active" class="ion-no-border">
    <div class="paired-button-container">
        <ion-button color="dark" class="paired-button" (click)="kickOnly()">
            Kick Only
        </ion-button>
        <ion-button [disabled]="formGroup.invalid" color="success" class="paired-button" (click)="kickAndReplace()">
            Kick And Replace
        </ion-button>
    </div>
</ion-footer>

<modal-footer *ngIf="!menuItemInventory.active" [disableSubmit]="formGroup.invalid" (submitClicked)="kickAndReplace()"
              submitLabel="Start"></modal-footer>
